export default __webpack_public_path__ + "static/CH_Painting-ff43fcad397d44d74ac55e86c6746307.svg";